import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'countryImage',
    standalone: true,
})
export class CountryImagePipe implements PipeTransform {
    transform(value: string): string {
        switch (value) {
            case 'en':
                return 'assets/vc-header-lib/countries_flags/usa.svg';
            case 'fr':
                return 'assets/vc-header-lib/countries_flags/french.svg';
            case 'es':
                return 'assets/vc-header-lib/countries_flags/spanish.svg';
            default:
                return 'assets/vc-header-lib/countries_flags/usa.svg';
        }
    }
}
